function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999; // Increase z-index further\n  // 배경색 등은 필요에 따라 추가 (투명 오버레이)\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "bottom: 100%; margin-bottom: 0.25rem;"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "left: 100%; margin-left: 0.25rem;"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "right: 100%; margin-right: 0.25rem;"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "top: 100%; margin-top: 0.25rem;"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "left: 0;"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "top: 0;"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "left: 50%; transform: translateX(-50%);"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "top: 50%; transform: translateY(-50%);"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "right: 0;"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "bottom: 0;"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: auto;\n  min-width: unset;\n  max-width: 90vw;\n  padding: 0;\n  background: #fff;\n  border-radius: 0.75rem;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.18);\n  border: 1px solid var(--theme-border-light, #e5e7eb);\n  opacity: 0;\n  transform: translateY(-8px);\n  animation: dropdown-fade-in 0.18s cubic-bezier(0.4,0,0.2,1) forwards;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent; /* 모바일 탭 하이라이트 제거 */\n  touch-action: manipulation; /* 모바일 터치 최적화 */\n\n  @keyframes dropdown-fade-in {\n    from { opacity: 0; transform: translateY(-8px); }\n    to { opacity: 1; transform: translateY(0); }\n  }\n\n  /* 모바일 최적화 */\n  @media (max-width: 768px) {\n    border-radius: 0.5rem;\n    box-shadow: 0 4px 16px rgba(0,0,0,0.15);\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { css } from '@emotion/react';
// Overlay 스타일
export var StyledDropdownOverlay = styled.div(_templateObject());
// 위치 계산 함수
var getPositionStyles = function(position) {
    switch(position){
        case 'top':
            return css(_templateObject1()); // bottom-full mb-1
        case 'right':
            return css(_templateObject2()); // left-full ml-1
        case 'left':
            return css(_templateObject3()); // right-full mr-1
        case 'bottom':
        default:
            return css(_templateObject4()); // top-full mt-1
    }
};
// 정렬 계산 함수
var getAlignStyles = function(position, align) {
    var isVertical = position === 'top' || position === 'bottom';
    switch(align){
        case 'start':
            return isVertical ? css(_templateObject5()) : css(_templateObject6()); // left-0 / top-0
        case 'center':
            return isVertical ? css(_templateObject7()) : css(_templateObject8()); // top-1/2 -translate-y-1/2
        case 'end':
        default:
            return isVertical ? css(_templateObject9()) : css(_templateObject10()); // right-0 / bottom-0
    }
};
// Dropdown Menu 스타일
export var StyledDropdownMenu = styled.div(_templateObject11(), function(param) {
    var position = param.position;
    return getPositionStyles(position);
}, function(param) {
    var position = param.position, align = param.align;
    return getAlignStyles(position, align);
});
